export const RISK_CLASS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  BANNED: 'banned',
} as const;

export const COMPANY_REPORT_STATUS = {
  NOT_FOUND: 'not_found',
  FOUND: 'found',
} as const;

export const TOAST_TIMEOUT = 5000;

export const ONGOING_STATUSES: ('opened' | 'started')[] = ['opened', 'started'];

export const PERIODIC_REVIEW_ORIGIN_STORAGE_KEY = 'periodic_review_origin';
export const IS_PERIODIC_WARNING_REVIEWED = 'isPeriodicWarningReviewed';
export const PERIODIC_REVIEW_POST_SUSPENSION_TOP_BANNER_DISMISSED_KEY =
  'PERIODIC_REVIEW_POST_SUSPENSION_TOP_BANNER_DISMISSED';
export const PERIODIC_REVIEW_SUSPENDED_TOP_BANNER_DISMISSED_KEY =
  'PERIODIC_REVIEW_SUSPENDED_TOP_BANNER_DISMISSED';
export const PERIODIC_REVIEW_TOP_BANNER_DISMISSED_KEY = 'PERIODIC_REVIEW_TOP_BANNER_DISMISSED';
